export interface User {
	id: string;
	name: string;
	avatar: string;
	reputation: number;
	ideasSubmitted: number;
	totalVotesReceived: number;
	joinedAt: string;
}

export interface IdeaVersion {
	id: string;
	ideaId: string;
	version: number;
	problem: string;
	solution: string;
	targetMarket: string;
	monetization: string;
	createdAt: string;
	authorId: string;
	changeNote: string;
}

export interface Idea {
	id: string;
	title: string;
	problem: string;
	solution: string;
	targetMarket: string;
	monetization: string;
	tags: string[];
	authorId: string;
	forkedFromId: string | null;
	createdAt: string;
	updatedAt: string;
	votes: number;
	votedBy: string[];
	commentCount: number;
	versions: IdeaVersion[];
	currentVersion: number;
}

export interface Comment {
	id: string;
	ideaId: string;
	authorId: string;
	content: string;
	createdAt: string;
}

export type SortOption = "trending" | "newest" | "top" | "weekly";
export type ViewMode = "feed" | "detail" | "submit" | "fork" | "rankings" | "profile";

export const INDUSTRY_TAGS = [
	"AI/ML",
	"SaaS",
	"Fintech",
	"Healthcare",
	"EdTech",
	"E-Commerce",
	"Social",
	"Climate",
	"DevTools",
	"Marketplace",
	"B2B",
	"B2C",
	"Crypto/Web3",
	"Gaming",
	"Media",
	"Real Estate",
	"Travel",
	"Food",
	"Logistics",
	"HR/Recruiting",
] as const;
